type MetadataItemProps = {
	icon: React.ReactNode;
	label: string;
	children: React.ReactNode;
};

export const MetadataItem = ({ icon, label, children }: MetadataItemProps) => (
	<div className="flex items-start gap-2 min-w-0">
		<div className="text-muted-foreground mt-0.5 shrink-0">{icon}</div>
		<div className="min-w-0">
			<p className="text-xs text-muted-foreground truncate">{label}</p>
			<div className="text-sm font-medium">{children}</div>
		</div>
	</div>
);
